<template>
    <div  @mouseover="$parent.panelHover = true"  @mouseleave="$parent.panelHover = false" >
    <div id="show-hide-panel-button" @click="showHidePanel" class="show-hide-panel-button">
        <div id="button-arrow" class="button-arrow"></div>
    </div>
    <div id="panel-container" class="panel-container">     
        <div class="panel-header">Risk of impact on biodiversity</div>


        <!-- SETTINGS -->
        <div id="panel-info">
            <div id="panel-info-header" @click="showHideSection('info')">
                <div id="triangle-info" class="triangle"></div>
                <div class="section-title">Settings</div>
            </div>
            <div id="panel-info-body">
                <!-- Cases -->
                <div class="setting-title">Cases</div>
                <div class="setting-container setting-container-row">
                    <div class="panel-content-line setting-element-row">
                        <input type="radio" id="case1" value="case1" name="case1" v-model="caseSelected">
                        <label class="check" for="mosaics-checkbox">Case 1</label>
                    </div>
                    <div class="panel-content-line setting-element-row">
                        <input type="radio" id="case2" value="case2" name="case2" v-model="caseSelected">
                        <label class="check" for="params-checkbox">Case 2</label>
                    </div>
                    <div class="panel-content-line setting-element-row">
                        <input type="radio" id="case3" value="case3" name="case3" v-model="caseSelected">
                        <label class="check" for="bathymetry-checkbox">Case 3</label>
                    </div>
                    <div class="panel-content-line setting-element-row">
                        <input type="radio" id="case4" value="case4" name="case4" v-model="caseSelected">
                        <label class="check" for="bathymetry-checkbox">Case 4</label>
                    </div>
                    <div class="panel-content-line setting-element-row">
                        <input type="radio" id="case5" value="case5" name="case5" v-model="caseSelected">
                        <label class="check" for="bathymetry-checkbox">Case 5</label>
                    </div>
                </div>
                <!-- Areas -->
                <div class="setting-title">Assesment area</div>
                <div class="setting-container">
                    <select class="custom-select" @change="checkLayer()" v-model="areaSelected">
                        <option disabled value="">Please, select an assesment area</option>
                        <option value="western">Western Mediterranean Sea</option>
                        <option value="adriatic">Adriatic Sea</option>
                        <option value="ionian">Ioninan Sea and the Central Mediterranean Sea</option>
                        <option value="aegean">Aegean-Levantine Sea</option>
                        <option value="pelagos">Pelagos Sactuary</option>
                    </select>
                </div>
                <!-- Period -->
                <div class="setting-title">Period</div>
                <div class="setting-container">
                    <select class="custom-select" v-model="periodSelected">
                        <option disabled value="">Please, select a period</option>
                        <option value="period1">May 2018 - Oct 2018</option>
                        <option value="period2">Nov 2018 - Apr 2019</option>
                    </select>
                </div>   
            </div>          
        </div>
        
        <div class="panel-separator"></div>

        <!-- LAYERS -->
        <div id="panel-capas">
            <div id="panel-capas-header" @click="showHideSection('capas')">
                <div id="triangle-capas" class="triangle"></div>
                <div class="section-title">Layers</div>
            </div>         
            <div id="panel-capas-body">
                <div class="panel-content-line">
                    <input type="radio" id="pressure" value="pressure" name="layer-pressure" v-model="layerSelected">
                    <label for="mosaics-checkbox">Pressure maps</label>
                </div>
                <div class="form-group text-center">
                    <input type="range" class="form-control-range"  min="80" max="180" step="1" v-model = pressuredBs>
                    <span >{{pressuredBs}} dB re 1uPa</span>
                </div>
                <!-- Species -->
                <div class="setting-title">Layers by species</div>
                <div class="setting-container">
                    <select class="custom-select" @change="checkLayer()" v-model="specieSelected">
                        <option disabled value="">Please, select a specie</option>
                        <option value="bp">Fin whale</option>
                        <option value="sc">Striped dolphin</option>
                        <option value="gg">Risso's dolphin</option>
                        <option value="pm">Sperm whale</option>
                        <option value="tt">Bottlenose dolphin</option>
                        <option value="zc">Cuvier's beaked whale</option>
                    </select>
                </div>
                <div class="panel-content-line">
                    <input type="radio" id="puha" value="puha" name="layer-puha" v-model="layerSelected">
                    <label for="params-checkbox">
                        <span data-tooltip="Potentially Usable Habitat Area" data-tooltip-position="right">PUHA </span>
                    </label>
                </div>
                <!-- <div class="panel-content-line">
                    <input type="radio" id="risk" value="risk" name="layer-risk" v-model="layerSelected">
                    <label for="bathymetry-checkbox">Risk map</label>
                </div> -->
                <div class="panel-content-line">
                    <input type="radio" id="ehai" value="ehai" name="layer-ehai" v-model="layerSelected">
                    <label for="sonar-checkbox"><span data-tooltip="Exposed Habitat Area Index" data-tooltip-position="right">EHAI</span></label>
                </div>
                <div class = "text-right">
                    <a>Download</a>
                </div>
            </div>
        </div>

        <div class="panel-separator"></div>

        <!-- Results -->
        <div id="panel-filtro">
            <div id="panel-filtro-header" @click="showHideSection('filtro')">
                <div id="triangle-filtro" class="triangle"></div>
                <div class="section-title">Calculations</div>
            </div>
            <div id="panel-filtro-body" ref="panelFiltroBody" class="">  
                <div class="result-line">
                    · Selected specie <b v-if = specieSelectedString> {{ specieSelectedString }}</b>
                </div> 
                <div class="result-line">
                    · Overall <span data-tooltip="Exposed Habitat Area Index" data-tooltip-position="right" >EHAI:</span> <b v-if = resultEHAI> {{ resultEHAI }}</b>
                </div>         
                <div class="result-line mt-1">
                    · Most endangered specie: <b> {{ resultMostEndangered }} </b>
                </div>
               <div class="result-line ">
                    · Overall <span data-tooltip="Exposed Habitat Area Index" data-tooltip-position="right" >EHAI:</span> <b v-if = resultMostEndangeredEHAI> {{ resultMostEndangeredEHAI }}</b>
                </div>
                <div class="result-line mt-1">
                    · Overall <span data-tooltip="Duration of Noise Events" data-tooltip-position="right" >DUNE:</span> <b v-if = resultDUNE> {{ resultDUNE }} % time </b>
                </div>
                <div class="btn-center-container">
                    <button @click="calculate()" class="btn btn-primary btn-calculate-risk">Calculate</button>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
  //import {getData} from './../../services/api'
  //import { mapGetters } from 'vuex'
  //import InfoPanel from '@/components/map/InfoPanel'
  //import InfoPanelMosaics from '@/components/map/InfoPanelMosaics'
  //import FilterPanelMosaics from '@/components/map/FilterPanelMosaics'

  export default {
    name: 'panel',
    components: {
        //InfoPanel,
        //InfoPanelMosaics,
        //FilterPanelMosaics,
    },
    data() {
        return {
            layerSelected: '',
            caseSelected: '',
            areaSelected: '',
            periodSelected: '',
            specieSelected: '',
            specieSelectedString: '',
            resultMostEndangered: '',
            resultMostEndangeredEHAI: '',
            resultEHAI: '',
            resultDUNE: '',
            coordinates: {
                latitude: '',
                longitud: ''
            },
            pressuredBs : 110
        };      
    },
    mounted:function () {
        //this.checkCase()
    },
    /*computed: {
        ...mapGetters(['isLayerParamsVisible', 'theme']),
        layerMosaicsVisible: {
            set () { this.$store.dispatch('changeMapLayersState', {layer: 'mosaics'}); },
            get () { return this.$store.state.mapLayers.layerMosaics.layerMosaicsVisible }
        },
        mosaicCampaignSelected: {
            get () { return this.$store.state.mapLayers.layerMosaics.mosaicCampaignSelected }
        }
    },*/
    watch: {
        'caseSelected': function () {
            this.checkCase()
        },
        'layerSelected': function () {
            this.checkLayer()
        },
    },
    methods: {
        checkCase() {

            this.layerSelected = ''
            this.areaSelected = 'western'
            this.specieSelected = 'sc'
            this.periodSelected = 'period1'

            this.$parent.showLayer(this.layerSelected,this.specieSelected,this.caseSelected);
   
            this.resultMostEndangered = ''
            this.resultEHAI = ''
            this.resultDUNE = ''
            this.specieSelectedString = ''
            this.resultMostEndangeredEHAI = ''
        },
        checkLayer() {
            if(this.areaSelected == 'western')
                this.$parent.showLayer(this.layerSelected,this.specieSelected,this.caseSelected);
            else
                this.$parent.showLayer('none',this.specieSelected,'case6');

        },
        calculate(){
            var scenario = {}

            var species = {  
                            'bp' : 'Fin whale (Bp)',
                            'sc' : 'Striped dolphin (Sc)',
                            'gg' : "Risso's dolphin (Gg)",
                            'pm' : 'Sperm whale (Pm)',
                            'tt' : 'Bottlenose dolphin (Tt)',
                            'zc' : "Cuvier's beaked whale (Zc)"
                        }

            switch (this.caseSelected) {
                case 'case1':
                    scenario = {
                        'especie' : "Fin whale (Bp)",
                        'ehai_especie': '9.980',
                        'ehai_westMED' : {
                            'bp' : '9.980',
                            'sc' : '8.565',
                            'gg' : '5.697',
                            'pm' : '8.860',
                            'tt' : '2.512',
                            'zc' : '5.316'
                        },
                        'dune' : {
                            'period1' : '25',
                            'period2' : '77',
                        }
                    }
                    break;
                case 'case2':
                    scenario = {
                        'especie' : "Bottlenose dolphin (Tt)",
                        'ehai_especie': '2.495',
                        'ehai_westMED' : {
                            'bp' : '2.002',
                            'sc' : '2.041',
                            'gg' : '2.097',
                            'pm' : '1.617',
                            'tt' : '2.495',
                            'zc' : '1.698'
                        },
                        'dune' : {
                            'period1' : '25',
                            'period2' : '77',
                        }
                    }
                    break;
                case 'case3':
                    scenario = {
                        'especie' : "Cuvier's beaked whale (Zc)",
                        'ehai_especie': '3.737',
                        'ehai_westMED' : {
                            'bp' : '3.298',
                            'sc' : '3.032',
                            'gg' : '2.391',
                            'pm' : '3.475',
                            'tt' : '2.307',
                            'zc' : '3.737'
                        },
                        'dune' : {
                            'period1' : '15',
                            'period2' : '25',
                        }
                    }
                    break;
                case 'case4':
                    scenario = {
                        'especie' : 'Fin whale (Bp)',
                        'ehai_especie': '4.917',
                        'ehai_westMED' : {
                            'bp' : '4.917',
                            'sc' : '4.255',
                            'gg' : '2.907',
                            'pm' : '4.470',
                            'tt' : '2.323',
                            'zc' : '4.066'
                        },
                        'dune' : {
                            'period1' : '15',
                            'period2' : '25',
                        }
                    }
                    break;
                case 'case5':
                    scenario = {
                        'especie' : 'Bottlenose dolphin (Tt)',
                        'ehai_especie': '2.292',
                        'ehai_westMED' : {
                            'bp' : '0.188',
                            'sc' : '0.618',
                            'gg' : '1.345',
                            'pm' : '0.409',
                            'tt' : '2.292',
                            'zc' : '1.134'
                        },
                        'dune' : {
                            'period1' : '10',
                            'period2' : '25',
                        }
                    }
                    break;
            }
            this.specieSelectedString = species[this.specieSelected]
            this.resultEHAI = scenario.ehai_westMED[this.specieSelected]

            this.resultMostEndangered = scenario.especie
            this.resultMostEndangeredEHAI = scenario.ehai_especie
            
            this.resultDUNE = scenario.dune[this.periodSelected]
           
        },
        showHidePanel(){
            var panelButton = document.getElementById("show-hide-panel-button");
            panelButton.classList.toggle("hide");
            var panelContainer = document.getElementById("panel-container");
            panelContainer.classList.toggle("hide");
            var buttonArrow = document.getElementById("button-arrow");
            buttonArrow.classList.toggle("right");
        },
        showHideSection(section){
            var triangle = document.getElementById("triangle-" + section);
            var body = document.getElementById("panel-" + section + "-body");
            triangle.classList.toggle("hide");
            body.classList.toggle("hide");
        }
    }
  }
</script>

<style scoped>
    .panel-container{
        z-index: 1900;
        position: absolute;
        background-color:rgba(255,255,255,0.98);
        top: 0;
        bottom: 16px;
        right: 0px;
        width: 400px;
        box-shadow: 0px 2px 5px grey;
        display: flex;
        flex-direction: column;
        padding: 10px 10px 10px 18px;       
        overflow-y: auto;   
    }
    #panel-container.hide{
        right: -400px;
    }
    .panel-header {
        background-color: rgba(230,230,230,0.8);
        height: 60px;
        margin: -10px -10px 5px -18px;
        padding-top: 5px;
        color: #666;
        font-weight: 600;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .show-hide-panel-button{
        z-index:1910;
        width: 30px;
        height: 30px;
        background-color: white;
        position: absolute;
        top: 15px;
        right: 385px;
        box-shadow: 0px 2px 5px grey;
        border-radius: 100%;
        cursor: pointer;
    }
    #show-hide-panel-button.hide{
        right: 5px;
    }
    .button-arrow{
        border: solid #ccc;
        border-width: 0 4px 4px 0;
        display: inline-block;
        padding: 4px;
        position: absolute;
        left: 8px;      
        top: 9px;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);      
    }
    #button-arrow.right {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
        left: 11px;       
    }
    #panel-capas-header, #panel-info-header, #panel-filtro-header {
        display: flex;
        flex-direction: row;
        cursor:pointer
    }
    #panel-capas-body, #panel-info-body, #panel-filtro-body {
        padding: 10px 10px 10px 18px;
        overflow: hidden;
        height: 100%;
        
        -webkit-transition: .1s ease-in-out;
        -moz-transition: .1s ease-in-out;
        -o-transition: .1s ease-in-out;
        transition: .1s ease-in-out;
    }
    #panel-capas-body.hide, #panel-info-body.hide, #panel-filtro-body.hide {
        padding: 0;
        height: 0px;
    }
    .panel-separator{
        height: 1px;
        background-color: #ccc;
        margin: 3px -10px 8px -18px;
    }
    .triangle {
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-left: 10px solid #5690DE;
        border-bottom: 5px solid transparent;
        position: relative;
        top: 7px;
        margin-right: 6px;
    
        transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
    }
    #triangle-capas.hide, #triangle-info.hide, #triangle-filtro.hide {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
    }
    .panel-content-line{
        font-size: small;
        line-height: 80%;
    }
    .infoPanel {
        padding: 10px 0px 10px 0px !important;
    }
    .infoPanel.hide {
        padding: 0px !important;
    }
    .section-title {
        font-size: 1rem;
        color: #00A7E3;
        font-weight: 600;
    }

    
    label {
        margin-left: 10px;
    }
    /*select {
        height: 30px;
        border: 1px solid darkgray;
        border-radius: 5px;
    }*/ 
    .custom-select {
        position: relative;
        font-family: Arial;
    }

    .custom-select select {
        display: none; /*hide original SELECT element: */
    }

    .select-selected {
        background-color: #00A7E3;
    }   
                                                                                                                             
    .setting-title {
        font-weight: 800;
        font-size: 0.8rem;
        margin-bottom: 5px;
    }       
    .setting-container-row {
        display: flex;
        flex-direction: row;
    }
    .setting-container {
        margin-bottom: 10px;
    }
    .setting-element-row {
        flex: 1;
    }
    .btn-center-container {
        width: 100%; 
        display: flex; 
        justify-content: center;
    }

    .result-line {
        font-size: 0.9rem;
    }
    /* **********   ANIMATIONS   ************ */
    #button-arrow,.panel-separator,.panel-separator-dark,.triangle,.triangle-dark,.panel-text-section-dark,.panel-text-1-dark,.panel-container,.panel-container-dark,.show-hide-panel-button,.show-hide-panel-button-dark {
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }

    .check {
        margin: 0px 0px 0px 4px;
    }


</style>